export function timesoffpwithworld(num) {
  return (num / 5).toFixed(1);
}
export function timesoffpwithindia(num) {
  return (num / 1.91).toFixed(1);
}
